<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="explore-guide">
    <vx-card title="Explore Options Guide" v-show="showGuide">
      <div class="vx-row">
        <div
          class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"
          v-for="guide in data"
          :key="guide.title"
          v-show="!guide.isDisabled"
        >
          <vx-card
            :title="guide.title"
            :subtitle="guide.subtitle"
            :title-color="guide === selectedGuide ? '#fff' : ''"
            :subtitle-color="guide === selectedGuide ? '#ddd' : '#ccc'"
            :card-background="guide === selectedGuide ? 'primary' : ''"
          >
            <!-- <template slot="actions">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template> -->
            <p
              class="mb-4"
              :class="guide === selectedGuide ? 'text-white' : 'text-grey'"
            >{{ guide.note }} {{ guide.mode ? 'revenue' : 'quantity sold'}}</p>
            <!-- <h5 :class="guide === selectedGuide ? 'text-white' : 'text-grey'">{{ guide.ref }}</h5> -->
            <div class="flex justify-between flex-wrap">
              <vs-switch class="mt-6" color="dark" v-model="guide.mode">
                <span slot="on">by $ Sales</span>
                <span slot="off">by Qty Sold</span>
              </vs-switch>
              <vs-button
                class="mt-4 shadow-lg"
                size="small"
                type="line"
                :color="guide === selectedGuide ? '' : 'primary'"
                @click="explore(guide)"
                v-bind="{'disabled' : (guide.isDisabled || guide === selectedGuide)}"
                v-if="guide.allowedTags"
              >{{guide === selectedGuide ? 'In Action' : (guide.isDisabled ? 'Locked' : 'Explore')}}</vs-button>
            </div>
          </vx-card>
        </div>
      </div>
    </vx-card>    
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    data: { type: Array, required: true }
  },
  data() {
    return {
      selectedGuide: null,
      showGuide: true,
    };
  },
  methods: {
    explore(guide) {
      this.selectedGuide = guide;
      this.$store.commit('sandbox/[SANDBOX] SET_SANDBOX_GUIDE_ON', guide);
    },
  },
  computed: {
  },
  mounted() {
    // this.$store.subscribe((mutation, state) => {
    //   console.log('Guide -> subscribe -> ',mutation.type)
      
    //   if(mutation.type === 'sandbox/'+SET_SANDBOX_GUIDE) {
    //     this.selectedGuide = state.guide; 
    //     console.log('Guide -> subscribe -> selectedGuide -> ',this.selectedGuide)
    //   } else if(mutation.type === 'sandbox/setArtefact') {
    //     if(mutation.payload && mutation.payload.res && mutation.payload.res.index && !mutation.payload.res.error) {
    //       this.showGuide = false;
    //     } else {
    //       this.showGuide = true;
    //     }
    //     console.log('Guide -> subscribe -> showGuide -> ',this.showGuide)
    //   }
    // });
    this.$store.watch((state, getters) => getters['sandbox/guideOn'],
      (newValue, oldValue) => {
        this.selectedGuide = newValue;
      }
    );   
    this.$store.watch((state, getters) => getters['sandbox/artefact'],
      (newValue, oldValue) => {
        if(newValue && !newValue.res.error && !newValue.res.warning) {
          this.showGuide = false;
        } else {
          this.showGuide = true;
        }
        if(newValue.type && (newValue.res.error || newValue.res.warning)) {
          this.$vs.notify({
                time: 2500,
                title: 'Info',
                text: newValue.res.error || newValue.res.warning,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        }
      }
    );    
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss">
#explore-guide {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}
</style>
